import React from 'react';
import styled from 'styled-components';

import { media, ymd } from '~/utils';

export default function ({ org }) {
  const values = [
    {
      label: '法人格',
      value: org.category,
    },
    {
      label: '法人名',
      value: org.name,
    },
    {
      label: '代表者名',
      value: `${org.ownerTitle} ${org.owner}`,
    },
    {
      label: '設立年月日',
      value: ymd(org.since),
    },
    {
      label: '本社所在地',
      value: `〒${org.displayPostalCode()}  ${org.prefecture}${org.address}`,
    },
    {
      label: '年間予算規模',
      value: org.budget,
    },
    {
      label: '従業員数',
      value: `常勤スタッフ ${org.fullTimeStaff}\n非常勤スタッフ ${org.partTimeStaff}`,
    },
    {
      label: 'ボランティア人数',
      value: org.volunteer,
    },
    {
      label: '取引先・取引銀行',
      value: org.client,
    },
  ];

  return (
    <Wrapper>
      <Title>法人概要</Title>
      <Main>
        {values.map((v, index) => (
          <Line key={index}>
            <Label>{v.label}</Label>
            <Value>{v.value}</Value>
          </Line>
        ))}
      </Main>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Line = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 18px;
  line-height: 40px;

  ${media.mid`
    margin-top: 15px;
    flex-direction: column;
  `}
`;

const Label = styled.div`
  width: 200px;

  ${media.mid`
    font-weight: bold;
  `}
`;

const Value = styled.div`
  white-space: pre-wrap;
`;

const Main = styled.div`
  padding: 20px 35px 40px;
`;
